
import { EpDevPApiRoutesFactoryBase } from '../api';
import EpDevPUtils from '../EpDevPUtils';
import { TEpDevPSortDirection } from '../types';

const IMPORT_PATH = "import";

export type TEpDevPOrganizationApiBasePathParam = {
  organizationId: string;
}
export type TEpDevPAssetApiBasePathParam = TEpDevPOrganizationApiBasePathParam;
export type TEpDevPApiListPathParam = TEpDevPAssetApiBasePathParam & {
}
export type TEpDevPApiDomainPathParam = TEpDevPAssetApiBasePathParam & {
  domainId: string;
}
export type TEpDevPApiDomainListPathParams = TEpDevPApiDomainPathParam & {
}
export type TEpDevPApiDomainByIdPathParams = TEpDevPApiDomainPathParam & {
  assetId: string;
}
export type TEpDevPApiManageAssetCreatePathParams = TEpDevPApiDomainPathParam;
export type TEpDevPApiManageAssetBasePathParams = TEpDevPApiDomainPathParam & {
  assetId: string;
}
export type TEpDevPApiManageAssetListPathParams = TEpDevPApiManageAssetBasePathParams;
export type TEpDevPApiManageAssetUpdatePathParams = TEpDevPApiManageAssetBasePathParams;
export type TEpDevPApiManageAssetDeletePathParams = TEpDevPApiManageAssetBasePathParams;

export type TEpDevPApiDomainByIdQueryParams = {
  version?: string;
}
export type TEpDevPApiBaseListQueryParams = {
  pageSize?: number;
  pageNumber?: number;
  searchTerm?: string;
  sortDirection?: TEpDevPSortDirection;
  sortFieldName?: string;
  // accessLevelList: Components.Parameters.AccessLevelList;
  // excludeApiProductIdList: Components.Parameters.ExcludeApiProductIdList;
  // apiProductIdList: Components.Parameters.ApiProductIdList;
  // source: APSApiProductSource;
}
export type TEpDevPApiListQueryParams = TEpDevPApiBaseListQueryParams & {
  domainIds?: Array<string>;
}
export type TEpDevPApiDomainListQueryParams = TEpDevPApiBaseListQueryParams & {
}


export class EpDevPAssetsApiRoutesFactory extends EpDevPApiRoutesFactoryBase {

  public static getSubRouteImportBatch = (): string => { 
    return `${EpDevPAssetsApiRoutesFactory.getSubRouteBase()}/${IMPORT_PATH}`;
  }

  public static getSubRouteBase = (): string => {
    return `/:${EpDevPUtils.nameOf<TEpDevPAssetApiBasePathParam>('organizationId')}`;
  }
  public static getSubRouteList = (): string => { 
    return EpDevPAssetsApiRoutesFactory.getSubRouteBase();
  }
  public static getSubRouteDomainBase = (): string => {
    return `${EpDevPAssetsApiRoutesFactory.getSubRouteBase()}/:${EpDevPUtils.nameOf<TEpDevPApiDomainPathParam>('domainId')}`;
  }
  public static getSubRouteDomainList = (): string => { 
    return EpDevPAssetsApiRoutesFactory.getSubRouteDomainBase();
  }
  protected static subRouteManageAsset = (): string => {
    return `${EpDevPAssetsApiRoutesFactory.getSubRouteDomainBase()}/:${EpDevPUtils.nameOf<TEpDevPApiManageAssetBasePathParams>('assetId')}`;
  }
  public static getSubRouteDomainById = (): string => {
    return EpDevPAssetsApiRoutesFactory.subRouteManageAsset();
  }
  public static postSubRouteManagedAssetCreate = (): string => {
    return this.getSubRouteDomainBase();
  }
  public static patchSubRouteManagedAssetUpdate = (): string => {
    return EpDevPAssetsApiRoutesFactory.subRouteManageAsset();
  }
  public static deleteSubRouteManagedAssetDelete = (): string => {
    return EpDevPAssetsApiRoutesFactory.subRouteManageAsset();
  }
}

export class EpDevPAssetsApiPathsFactory {

  public static createImportPath({ organizationId }:{
    organizationId: string;
  }): string {
    return `/${organizationId}/${IMPORT_PATH}`;
  }

  public static createAssetLocation = ({ locationBasePath, organizationId, domainId, assetId, versionString }:{
    locationBasePath: string;
    organizationId: string;
    domainId: string;
    assetId: string;
    versionString?: string;
  }): string => {
    let location = `${locationBasePath}/${organizationId}/${domainId}/${assetId}`;
    if(versionString) location += `?${EpDevPUtils.nameOf<TEpDevPApiDomainByIdQueryParams>('version')}=${versionString}`;
    return location;
  }

  public static createListPath({ 
    organizationId, 
    domainIds,
    pageSize,
    pageNumber,
    searchTerm,
    sortDirection,
    sortFieldName,
  }: {
    organizationId: string;
    domainIds?: Array<string>;
    pageSize?: number;
    pageNumber?: number;
    searchTerm?: string;
    sortDirection?: TEpDevPSortDirection;
    sortFieldName?: string;
  }): string {
    const queryParams: string[] = [];
    if(pageSize) queryParams.push(`${EpDevPUtils.nameOf<TEpDevPApiListQueryParams>("pageSize")}=${pageSize}`);
    if(pageNumber) queryParams.push(`${EpDevPUtils.nameOf<TEpDevPApiListQueryParams>("pageNumber")}=${pageNumber}`);
    if(searchTerm) queryParams.push(`${EpDevPUtils.nameOf<TEpDevPApiListQueryParams>("searchTerm")}=${searchTerm}`);
    if(sortDirection) queryParams.push(`${EpDevPUtils.nameOf<TEpDevPApiListQueryParams>("sortDirection")}=${sortDirection}`);
    if(sortFieldName) queryParams.push(`${EpDevPUtils.nameOf<TEpDevPApiListQueryParams>("sortFieldName")}=${sortFieldName}`);
    if(domainIds) queryParams.push(`${EpDevPUtils.nameOf<TEpDevPApiListQueryParams>("domainIds")}=${domainIds.join(',')}`);

    const queryString = queryParams.length ? queryParams.join('&') : '';
    return `/${organizationId}?${queryString}`;
  }

  public static createDomainListPath({ 
    organizationId, 
    domainId,
    pageSize,
    pageNumber,
    searchTerm,
    sortDirection,
    sortFieldName,
  }: {
    organizationId: string;
    domainId: string;
    pageSize?: number;
    pageNumber?: number;
    searchTerm?: string;
    sortDirection?: TEpDevPSortDirection;
    sortFieldName?: string;
  }): string {
    const queryParams: string[] = [];
    if(pageSize) queryParams.push(`${EpDevPUtils.nameOf<TEpDevPApiDomainListQueryParams>("pageSize")}=${pageSize}`);
    if(pageNumber) queryParams.push(`${EpDevPUtils.nameOf<TEpDevPApiDomainListQueryParams>("pageNumber")}=${pageNumber}`);
    if(searchTerm) queryParams.push(`${EpDevPUtils.nameOf<TEpDevPApiDomainListQueryParams>("searchTerm")}=${searchTerm}`);
    if(sortDirection) queryParams.push(`${EpDevPUtils.nameOf<TEpDevPApiDomainListQueryParams>("sortDirection")}=${sortDirection}`);
    if(sortFieldName) queryParams.push(`${EpDevPUtils.nameOf<TEpDevPApiDomainListQueryParams>("sortFieldName")}=${sortFieldName}`);
    const queryString = queryParams.length ? queryParams.join('&') : '';
    return `/${organizationId}/${domainId}?${queryString}`;
  }

  public static createDomainByIdPath({ organizationId, domainId, assetId, versionString }: {
    organizationId: string;
    domainId: string;
    assetId: string;
    versionString?: string;
  }): string {
    const queryParams: string[] = [];
    if(versionString !== undefined) queryParams.push(`${EpDevPUtils.nameOf<TEpDevPApiDomainByIdQueryParams>("version")}=${versionString}`);
    const queryString = queryParams.length ? queryParams.join('&') : '';
    return `/${organizationId}/${domainId}/${assetId}?${queryString}`;
  }

  protected static managedAssetPath({ organizationId, domainId, assetId }: {
    organizationId: string;
    domainId: string;
    assetId?: string;
  }): string {
    if(assetId) return `/${organizationId}/${domainId}/${assetId}`;
    return `/${organizationId}/${domainId}`;
  }

  public static managedAssetCreatePath({ organizationId, domainId }: {
    organizationId: string;
    domainId: string;
  }): string {
    return EpDevPAssetsApiPathsFactory.managedAssetPath({ organizationId: organizationId, domainId: domainId });
  }

  public static managedAssetUpdatePath({ organizationId, domainId, assetId }: {
    organizationId: string;
    domainId: string;
    assetId: string;
  }): string {
    return EpDevPAssetsApiPathsFactory.managedAssetPath({
      organizationId: organizationId,
      domainId: domainId,
      assetId: assetId
    });
  }

  public static managedAssetDeletePath({ organizationId, domainId, assetId }: {
    organizationId: string;
    domainId: string;
    assetId: string;
  }): string {
    return EpDevPAssetsApiPathsFactory.managedAssetPath({
      organizationId: organizationId,
      domainId: domainId,
      assetId: assetId
    });
  }

}

